module.exports = __webpack_public_path__ + "static/media/affiliate-banner-es.5045b77f.png";